import slugify from 'slugify';
import { VIEW_AS_QUERY_PARAM } from '../constants/bzm-constants';
import { VIEW_AS_EXCLUDE_PREFIXES } from '../constants/viewAsWhiteList';

/**
 * Creates seo friendly name from a given string and identifier.
 * @param id
 * @param name
 */
export const createSlug = (name: string, id?: string | number) => {
  return (id ? id + '-' : '') + slugify(name, { lower: true });
};

/**
 * Gets id from the slug created by createSlug().
 * @param slug
 */
export const getIdFromSlug = (slug: string) => {
  const tokenized = slug.split('-');
  return tokenized[0] ? tokenized[0] : null;
};

/**
 * Removes parameter from url.
 * (https://stackoverflow.com/questions/1634748/how-can-i-delete-a-query-string-parameter-in-javascript)
 * @param key
 * @param sourceUrl
 */
export const removeUrlParam = (key: string, sourceUrl: string) => {
  let rtn = sourceUrl.split('?')[0];
  let param;
  let paramsArr = [];
  const queryString = sourceUrl.indexOf('?') !== -1 ? sourceUrl.split('?')[1] : '';

  if (queryString !== '') {
    paramsArr = queryString.split('&');
    for (let i = paramsArr.length - 1; i >= 0; i -= 1) {
      param = paramsArr[i].split('=')[0];
      if (param === key) {
        paramsArr.splice(i, 1);
      }
    }
    if (paramsArr.length) rtn = rtn + '?' + paramsArr.join('&');
  }
  return rtn;
};

/**
 * Appends view_as parameter to the URL string.
 * URLs matching any prefix in excludePrefixes are returned unchanged.
 * @param url - The URL to append the view_as parameter to.
 * @param viewAsId - The user ID to set as the view_as parameter value.
 * @param excludePrefixes - List of URL prefixes for which the parameter should not be appended.
 * Defaults to VIEW_AS_EXCLUDE_PREFIXES.
 */
export const appendViewAs = (url: string, viewAsId: number, excludePrefixes: string[] = VIEW_AS_EXCLUDE_PREFIXES) => {
  if (excludePrefixes.some(prefix => url.startsWith(prefix))) {
    return url;
  }
  if (url.indexOf('?') === -1) {
    url += '?';
  } else {
    url += '&';
  }
  url += VIEW_AS_QUERY_PARAM + '=' + viewAsId;
  return url;
};
